import { render, staticRenderFns } from "./TableInspectDouble.vue?vue&type=template&id=c58be2be&scoped=true"
import script from "./TableInspectDouble.vue?vue&type=script&lang=js"
export * from "./TableInspectDouble.vue?vue&type=script&lang=js"
import style0 from "./TableInspectDouble.vue?vue&type=style&index=0&id=c58be2be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58be2be",
  null
  
)

export default component.exports